/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AlertAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function AlertAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Medical/Content/Content/Categories/Category/Questions/Question/Actions/AlertAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let categoryIdValueData = fromData.useDataValue({ viewPath,
context: 'category',
path: 'id',
})
let questionTypeValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'type',
})
let categoryDisabledValueData = fromData.useDataValue({ viewPath,
context: 'category',
path: 'disabled',
})
let aggregateData = fromHelpers.getView(categoryIdValueData, questionTypeValueData, categoryDisabledValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}